import { useEffect } from 'react';
import '../styles/GeneralStyles.css';

const CalendlyStep = ({prevStep, nextStep}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="container-large">
      <div className="wrapp-calandly">
        <div className="column-content-calendly">
            <div className="text-n-options">
                <h2>Agenda una llamada con nosotros</h2>
                <p>Selecciona el horario que mejor te convenga para discutir los detalles de tu anillo.</p>
            </div>
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/josetepaz28/30min?month=2025-02"
            style={{ minWidth: '320px', height: '700px' }} 
          />
        </div>
      </div>
    </div>
  );
};

export default CalendlyStep;
